import { EventEmitter } from '../classes/EventEmitter';
import { SessionLocalStorage, SessionStorage } from './SessionLocalStorage';

export enum events {
    create = 'create',
    destroy = 'destroy',
}

export interface SessionSerializableData<T> {
    exp: number | null;
    data: T;
}

export enum timePeriods {
    DAY = 1000 * 60 * 60 * 24,
    WEEK = 1000 * 60 * 60 * 24 * 7,
}

export class Session<T> extends EventEmitter {
    private exp: number | null = null;
    private storage: SessionStorage<SessionSerializableData<T>>;
    public data: T | null = null;

    static timePeriods = timePeriods;

    static getExpiresIn(timePeriod: number): number {
        return Date.now() + timePeriod;
    }

    static createFromStorage() {
        const session = new Session();

        session.tryToRestoreSessionFromStorage();

        return session;
    }

    constructor() {
        super();
        this.storage = new SessionLocalStorage();
    }

    public setSessionData(exp: number, data: T) {
        this.exp = exp;
        this.data = data;

        this.storage.save({
            exp,
            data,
        });

        this.trigger(events.create);
    }

    public destroy() {
        this.exp = null;
        this.data = null;
        this.storage.destroy();

        this.trigger(events.destroy);
    }

    public tryToRestoreSessionFromStorage() {
        const dataFromStorage = this.storage.get();

        if (!dataFromStorage) return;

        if (!this.isAuthenticated(dataFromStorage.exp)) return;

        this.exp = dataFromStorage.exp;
        this.data = dataFromStorage.data;
    }

    public isAuthenticated(exp: number | null = this.exp): boolean {
        return Boolean(exp && Date.now() < exp);
    }
}
